module.exports = __webpack_public_path__ + "static/media/ChillWARE2_FAKE.94618ecc.png";